import './spinnerstown/style';
import FormStructure from './spinnerstown/form_structure';

export default FormStructure;